export default "__VITE_PUBLIC_ASSET__b397b1f0__"